import { createFileRoute, notFound } from "@tanstack/react-router";

// Unknown paths under a valid language show the 404 page; invalid languages are
// redirected to /en by the parent $lang route before this runs.
export const Route = createFileRoute("/$lang/$")({
  beforeLoad: () => {
    throw notFound();
  },
});
